import React, { useState, useCallback,useRef , useContext, useEffect } from 'react'
import { ChatItem, } from 'react-chat-elements';
import "react-chat-elements/dist/main.css";
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import { useFetch } from '../api/FetchApiData';
import { useInfiniteScroll } from '../utils/InfiniteScroll';
import { UserContext } from '../../AppContextProvider';
//import WsNotifications from '../api/WsNotifications';
import Messagerie, { Message } from '../user/messagerie/Messagerie';
import { ButtonLoader } from '../utils/ButtonLoader';
import chat_icon from './icons/chat.png';
import rikinaze_logo from './icons/rikinaze.png';
import { FloatingWhatsApp } from "react-floating-whatsapp";
import('./ChatBot.css').then(() => {});



const IsWritting = ()=>{
    return(<div className='dots-loader'>
        <span></span>
        <span></span>
        <span></span>
    </div>)
}

function ChatBot({close=()=>{}}) {
    /*
    const [showConv,setShowConv] = useState(false);
    const [messages, setMessages] = useState([])
    const [page,setPage] = useState({CurrentPage:1,MaxPage:10});
    const [hasMore,setHasMore] = useState(true);
    const _close = ()=>setShowConv(!showConv);
    const fetchData = useFetch();
    const [User,setUser] = useContext(UserContext);
    const [typing,setTyping] = useState(false);
    const [convNumber, setConvNumber] = useState(null);
    const [TextAreaMaxHeight,setTextAreaMaxHeight] = useState("50px");
    const [sLoading,setSLoading] = useState(false);
    const [newMessage,setNewMessage] = useState({text:''});
    const [messBottomMargin,setMessBottomMargin] = useState('75px');
    const ref_messeages = useRef([]);
    const bottom_ref = useRef(null);
    const inputDivRef = useRef();
    
    const FetchMessages = useCallback(async ()=>{
        if(!hasMore)
            return
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.GetData(`user/messaging/${convNumber}/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    setMessages([...messages,...result.messages]);
                    ref_messeages.current = [...messages,...result.messages];
                    setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});
                    if(page.CurrentPage>=result.maxpage)
                        setHasMore(false);
                    else
                    {
                        
                    }
                }
            })
        }
    },[page, hasMore, convNumber, showConv])

    const LoadMoreMessagesRef = useInfiniteScroll(FetchMessages,hasMore);

    const SendMessage=()=>
    {
        const _data = {messag_chat:true, text:newMessage.text, datetime:Date.now(),conversation_number:convNumber};
        //console.log(_data);
        //WsNotifications.send(_data);
        fetchData.PutData(_data,'user/conversations/').then((result)=>{
        if(result.result)
        {
                messages.push(result.tx);
                if(!!result.rx)
                    messages.push(result.rx);
                setMessages([...messages]);
            }
        })
        setNewMessage({text:""});
        setTextAreaMaxHeight("50px");
        setMessBottomMargin('75px');
    }

    const ChatMessage = (data)=>{
        if(data.type === 'message')
        {
            ref_messeages.current.push(data.message);
            const arr = ref_messeages.current
            setMessages(arr);
        }
        else if(data.type === 'typing')
        {
            setTyping(true);
            setTimeout(()=>{setTyping(false);},10000);
            console.log(data);
        }
        setTimeout(()=>{bottom_ref.current?.scrollIntoView({behavior:"smooth"})},1000);
    }

    useEffect(()=>{
        let rik_id = sessionStorage.getItem('rikinaze_id');
        console.log(rik_id);
        if(!!rik_id)
        {
            setConvNumber(rik_id);
        }
        return ()=>{
            const _data = {discard_chat:true}
        }
    },[])

    useEffect(()=>{
        //console.log('scrolling ...');
        //bottom_ref.current?.scrollIntoView({behavior:"smooth"})
    },[messages])
    
    useEffect(()=>{
        if(convNumber==null || !showConv)
            return

        /*
        const _data = {add_chat:true, chat_channel:convNumber};
        if(!WsNotifications.is_online())
        {
            const onConnected = ()=>{
                WsNotifications.send(_data);
                WsNotifications.authentication();
            }
            WsNotifications.connect(User.auth,onConnected,null,"ChatBot");
            WsNotifications.send(_data);
             
        }
        else{
                WsNotifications.send(_data);
                console.log('adding ...'); 
        }
        */
       /*
        setHasMore(showConv);
    },[convNumber,showConv])

    if(showConv)
    {
        return (
            <div className='user-robot-chatbot'>
                {(!!convNumber) && <Messagerie con_number={convNumber} home_chat_bot={true} />}
                <div className='user-robot-title' style={{zIndex:'999999'}}>                
                    <label style={{display:'inline-block',paddingLeft:'20px'}}>Assistance</label>
                    <label onClick={e=>{_close();}} className='CloseConv'>x</label>
                </div>
            </div>
        )
    
    }
    else
    {
        if(!isMobile)
            return(
                <div style={{position:'fixed',bottom:'30px',right:'60px'}}>
                    <img onClick={e=>setShowConv(!showConv)} src={chat_icon} style={{width:'80px'}}/>
                </div>
            );
    }*/
    return(<FloatingWhatsApp
                phoneNumber="33760192005"
                accountName="Service client"
                avatar={rikinaze_logo}
                statusMessage="Répond en quelques minutes"
                chatMessage="Bonjour 👋 Comment puis-je vous aider ?"
                placeholder="Écrivez votre message..."
                darkMode={false}
                />)
        }

export default ChatBot;